module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader",
    style: ({
      'border-top-color': _vm.color,
      width: _vm.size,
      height: _vm.size,
      'border-width': _vm.thickness,
      'animation-duration': _vm.speed
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c8b1a74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Loader.vue
// module id = 1326
// module chunks = 1